"use strict";
angular.module("planCommandMonitorOncePublicOpinionModule", 
    ["planCommandMonitorOncePublicOpinionAddEditModule","headlinesHotListPageModule"])
    .controller('planCommandMonitorOncePublicOpinionCtrl', ['$scope','trsHttpService','modalDialog','$state','planCommandMonitorService','$modal',
        function($scope,trsHttpService,modalDialog,$state,planCommandMonitorService,$modal) {
            initStatus();
            initData();
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                $scope.params = {
                    modalname: "pubSentimentMgr",
                    method: "findPubSentis",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen",
                    page_no: $scope.page.CURRPAGE - 1,
                    page_size: $scope.page.PAGESIZE
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                    $scope.list = data.mapResult.content.content;
                    $scope.page.ITEMCOUNT = data.mapResult.content.totalElements;
                    $scope.page.PAGECOUNT = data.mapResult.content.totalPages;
                });
            };
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {                
                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 20,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1
                };
                $scope.status = {
                    "copyCurrPage": 1
                };
            };
            /**
             * [selectPageNum description] 单页面显示数据个数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                initData();
            };
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                initData();
            };
            /**
             * [pageChanged description] 页面切换
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                initData();
            };
            /**
             * [$scope.share description:打开分享弹窗]
             */
            $scope.share = function(id) {               
             planCommandMonitorService.share(id,"6","复制链接和密码");                       
            };
            /**
             * [scan description] 页面一屏、九屏样式按钮链接
             * @param  {[type]} url [链接地址] 
             * @return {[type]}     [description]
             */
            $scope.scan = function(url) {
                window.open(url);
            };
            /**[examine description]打开新的查看页面
             * @param  "type" pid [路由跳转参数] 
             * @param  "type" pname [路由跳转参数] 
             */
            $scope.examine = function(pid,pname) {
                //var url=$state.href("plan.oncepubsentiment.laf",{id:pid,name:pname});
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/oncePublicOpinion/listPage/headlinesHotListPage_tpl.html",                    
                    windowClass: 'headlinesHotListPage',
                    backdrop: false,
                    controller: "headlinesHotListPageCtrl",
                    resolve: {
                        itemInfo: function() {
                            return {
                                id:pid,
                                name:pname
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    if (angular.isFunction(confirm)) confirm();
                }, function() {
                    // if (angular.isFunction(cancel)) cancel();
                });
               
            };
            /**[compile description]打开新的编辑页面
             * 
             */
            $scope.compileOradd=function(id){
               if(angular.isUndefined(id)){
                     id="";
               }
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/oncePublicOpinion/oncePublicOpinionAddEdit/oncePublicOpinion_add_edit_tpl.html",
                    windowClass: 'oncePublicOpinion_add_edit',
                    backdrop: false,
                    controller: "planCommandMonitorOncePublicOpinionAddEditCtrl",
                    resolve: {
                        paramsId:{
                            id:id
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                       initData();
                }, function() {
                       initData();
                });             
            };
            /**             
             * [deletepubsentiment description] 通过id删除舆情数据
             * @param  {[type]} id [舆情id] 
             * @return {[type]}     [description]
             */            
            $scope.deletepubsentiment = function(id) {
                modalDialog.confirmModal("删除提示", "是否确定删除？", function() {
                    var params = {
                        modalname: "pubSentimentMgr",
                        method: "deletepubsentimentbyid",
                        methodname: "queryDataFromBigScreen",
                        serviceid: "mlf_bigdatascreen",
                        id: id
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        initData();
                    });
                });

            };
        }
    ]);